// extracted by mini-css-extract-plugin
module.exports = {"buttonAddResponsiblePerson":"adminTabList_buttonAddResponsiblePerson__2yDj2","containing":"adminTabList_containing__1Qn2P","tabs":"adminTabList_tabs__3Erlf"};